import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import * as moment from "moment";
import { BehaviorSubject } from "rxjs";
import { take } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { ClaimActionModalComponent } from "../components/modals/claim-action-modal/claim-action-modal.component";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { StorageService } from "src/app/services/storage.service";
import { AgreementActionsModalComponent } from "../components/modals/agreement-actions-modal/agreement-actions-modal.component";

@Injectable({
  providedIn: "root",
})
export class AgreementActionsService {
  constructor(
    private apiService: ApiService,
    public dialog: MatDialog,
    private storageService: StorageService
  ) {}

  private fetchViewAgreementData$ = new BehaviorSubject(false);
  public shouldViewFetchAgreement$ =
    this.fetchViewAgreementData$.asObservable();
    private fetchViewAgreementKPI$ = new BehaviorSubject(false);
    public shouldFetchAgreementKPI$ =
      this.fetchViewAgreementKPI$.asObservable();

  waitingPeriodsForm = new FormGroup({
    waitingPeriod: new FormControl("", [Validators.required]),
  });
  customerScoreForm = new FormGroup({
    customerScore: new FormControl("", [Validators.required]),
  });

  contactInfoModalForm = new FormGroup<any>({
    firstName: new FormControl("", [Validators.required]),
    lastName: new FormControl("", [Validators.required]),
    phoneNumber: new FormControl("", [Validators.required]),
    emailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),
  });
  superDiscountPriceForm = new FormGroup({
    previousDiscountPrice: new FormControl(0),
    discountedPrice: new FormControl("", [Validators.required]),
  });

  agreementHolderForm = new FormGroup<any>({
    firstName: new FormControl("", [Validators.required]),
    lastName: new FormControl("", [Validators.required]),
    phoneNumber: new FormControl("", [Validators.required]),
    emailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),
  });
  sendEscrowConfirmationMailForm = new FormGroup({
    emailAddress : new FormControl("", [Validators.required, Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/)]),
  });
  freeMonthForm = new FormGroup({
    freeMonth: new FormControl("", [Validators.required]),
  });

  formList = {
    updateWaitingPeriod: this.waitingPeriodsForm,
    updateCustomerScore: this.customerScoreForm,
    updateContactInfo: this.contactInfoModalForm,
    updateAgreementHolderDetail: this.agreementHolderForm,
    updateSuperDiscountedPrice: this.superDiscountPriceForm,
    sendEscrowConfirmationMail: this.sendEscrowConfirmationMailForm,
    updateFreeMonth: this.freeMonthForm
  };

  updateAgreementInfo(
    agreementId: string,
    actionValue: any,
    modalName: string
  ) {
    const agentId = this.storageService.getUser()?.userId;
    const payload = this.createPayload(modalName, actionValue, agentId);
    this.fetchViewAgreementData$.next(false);
    this.fetchViewAgreementKPI$.next(false);
    this.apiService
      .post(
        endpoints.customerDashboard.updateAgreement(agreementId, modalName),
        payload
      )
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          this.apiService.alert(res.body.message, ErrorType.Success);
          if(modalName === "updateCustomerScore") {
            this.fetchViewAgreementKPI$.next(true);
          } else {
            this.fetchViewAgreementData$.next(true);
          }
        },
        (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        }
      );
  }

  createPayload(modalName: string, actionValue: any, agentId) {
    let payload: any = {};

    switch (modalName) {
      case "updateWaitingPeriod":
        payload = actionValue;
        break;

        case "updateCustomerScore":
          payload = actionValue;
          break;

          case "updateContactInfo":
            payload = {
              contactInformation: actionValue
            };
            break;

            case "updateAgreementHolderDetail":
              payload = actionValue;
              break;
            
            case "sendEscrowConfirmationMail":
            payload = actionValue;
            break;

            case "updateFreeMonth":
            payload = actionValue;
            break;

      default:
        break;
    }
    return payload;
  }

  openActionModal(agreementId: string, modalName: string) {
    const data = {
      agreementId,
      formGroup: this.formList[modalName],
      actionModal: modalName
    };
    this.dialog
      .open(AgreementActionsModalComponent, {
        data: data,
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (!res?.actionValue) return;

        switch (modalName) {
          case "updateWaitingPeriod": {
            this.updateAgreementInfo(agreementId, res?.actionValue, modalName);
            break;
          }
          case "updateCustomerScore": {
            this.updateAgreementInfo(agreementId, res?.actionValue, modalName);
            break;
          }

          case "updateContactInfo": {
            this.updateAgreementInfo(agreementId, res?.actionValue, modalName);
            break;
          }

          case "updateAgreementHolderDetail": {
            this.updateAgreementInfo(agreementId, res?.actionValue, modalName);
            break;
          }
          case "sendEscrowConfirmationMail": {
            this.updateAgreementInfo(agreementId, res?.actionValue, modalName);
            break;
          }
           case "updateFreeMonth": {
            this.updateAgreementInfo(agreementId, res?.actionValue, modalName);
            break;
          }
          default: {
            break;
          }
        }
      });
  }
}
